import { Action } from 'redux';
import {
    GET_OPENED_COUNTRIES_REQUEST,
    GET_OPENED_COUNTRIES_RESPONSE,
    GET_OPENED_COUNTRIES_ERROR
} from '../../actions/OpenedCountries/openedCountries';
import { OpenedCountry } from '../../models/OpenedCountries/openedCountries';

export interface OpenedCountriesState {
    countries: Array<OpenedCountry>;
    loading: boolean;
    error: string;
}

const initialState: OpenedCountriesState = {
    countries: [],
    loading: false,
    error: ''
};

export const openedCountriesState = (state: OpenedCountriesState = initialState, action: Action): OpenedCountriesState => {
    switch (action.type) {
        case GET_OPENED_COUNTRIES_REQUEST: {
            return {
                ...state,
                loading: true
            };
        }
        case GET_OPENED_COUNTRIES_RESPONSE: {
            const countries = (action as any).response.result;
            return {
                ...state,
                countries,
                loading: false
            };
        }
        case GET_OPENED_COUNTRIES_ERROR: {
            console.error((action as any).error);
            return {
                ...state,
                loading: false,
                error: (action as any).error
            };
        }
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/OpenedCountries/openedCountries.ts